import { FC } from 'react';

import { SelectorCardCarousel } from '../../components/shared/SelectorCardCarousel';
import { useResolvedTheme } from '../../hooks/useResolvedTheme';
import { Universe } from '../../types';

interface Props {
    readonly universes: Universe[];
    readonly buildHref?: (universe: Universe) => string;
    readonly testIdPrefix?: string;
}

export const UniverseCarousel: FC<Props> = ({
    universes,
    buildHref,
    testIdPrefix,
}) => {
    const resolvedTheme = useResolvedTheme();

    if (!universes) {
        return null;
    }

    const items = universes.map((universe) => ({
        id: universe.id,
        name: universe.name,
        image:
            resolvedTheme === 'dark'
                ? universe.slider_image_dark || universe.slider_image
                : universe.slider_image,
        href: buildHref ? buildHref(universe) : universe.url_path,
        slug: universe.slug,
    }));

    return <SelectorCardCarousel items={items} testIdPrefix={testIdPrefix} />;
};
